/* ====================================================================
   VORTEC THEME — JAVASCRIPT
   ==================================================================== */

(function () {
  'use strict';

  // ===== TOAST NOTIFICATIONS =====
  const toast = {
    el: null,
    timer: null,
    show(message) {
      if (!this.el) this.el = document.getElementById('toast');
      if (!this.el) return;
      this.el.textContent = message;
      this.el.classList.add('show');
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.el.classList.remove('show'), 2000);
    }
  };

  // ===== CART DRAWER =====
  const cartDrawer = {
    overlay: null,
    drawer: null,
    body: null,
    countEls: null,

    init() {
      this.overlay = document.getElementById('cart-drawer-overlay');
      this.drawer = document.getElementById('cart-drawer');
      this.body = document.getElementById('cart-drawer-body');
      this.countEls = document.querySelectorAll('[data-cart-count]');

      if (!this.drawer) return;

      // Open triggers
      document.querySelectorAll('[data-cart-toggle]').forEach(el => {
        el.addEventListener('click', e => {
          e.preventDefault();
          this.open();
        });
      });

      // Close triggers
      document.querySelectorAll('[data-cart-close]').forEach(el => {
        el.addEventListener('click', () => this.close());
      });
      if (this.overlay) {
        this.overlay.addEventListener('click', () => this.close());
      }

      // Close on escape
      document.addEventListener('keydown', e => {
        if (e.key === 'Escape' && this.drawer.classList.contains('open')) {
          this.close();
        }
      });

      // Refresh on load
      this.refresh();
    },

    open() {
      this.drawer.classList.add('open');
      if (this.overlay) this.overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    },

    close() {
      this.drawer.classList.remove('open');
      if (this.overlay) this.overlay.classList.remove('open');
      document.body.style.overflow = '';
    },

    async refresh() {
      try {
        const res = await fetch('/cart.js');
        const cart = await res.json();
        this.render(cart);
      } catch (err) {
        console.error('Cart fetch failed:', err);
      }
    },

    render(cart) {
      // Update count badges
      this.countEls.forEach(el => {
        el.textContent = cart.item_count;
      });

      if (!this.body) return;

      if (cart.item_count === 0) {
        this.body.innerHTML = `
          <div class="cart-drawer__empty">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="9" cy="21" r="1"/>
              <circle cx="20" cy="21" r="1"/>
              <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
            </svg>
            <p>Empty bag.<br>Go grab some gear.</p>
          </div>
        `;
        const checkoutBtn = document.getElementById('cart-checkout');
        if (checkoutBtn) checkoutBtn.disabled = true;
        const totalEl = document.getElementById('cart-total');
        if (totalEl) totalEl.textContent = formatMoney(0);
        return;
      }

      let html = '';
      cart.items.forEach(item => {
        const img = item.image ? `<img src="${item.image}" alt="${escapeHtml(item.product_title)}" loading="lazy">` : '';
        const variantInfo = item.variant_title && item.variant_title !== 'Default Title'
          ? `<p>${escapeHtml(item.variant_title)}</p>`
          : '';
        html += `
          <div class="cart-drawer__item" data-line-key="${item.key}">
            <div class="cart-drawer__item-img">${img}</div>
            <div class="cart-drawer__item-info">
              <h4><a href="${item.url}">${escapeHtml(item.product_title)}</a></h4>
              ${variantInfo}
              <div class="cart-drawer__qty">
                <button type="button" data-qty-change="-1" aria-label="Decrease quantity">−</button>
                <input type="number" value="${item.quantity}" min="0" data-qty-input>
                <button type="button" data-qty-change="1" aria-label="Increase quantity">+</button>
              </div>
              <button type="button" class="cart-drawer__remove" data-remove>Remove</button>
            </div>
            <div class="cart-drawer__item-price">${formatMoney(item.line_price)}</div>
          </div>
        `;
      });
      this.body.innerHTML = html;

      // Wire up qty buttons
      this.body.querySelectorAll('.cart-drawer__item').forEach(itemEl => {
        const key = itemEl.dataset.lineKey;
        itemEl.querySelectorAll('[data-qty-change]').forEach(btn => {
          btn.addEventListener('click', () => {
            const input = itemEl.querySelector('[data-qty-input]');
            const change = parseInt(btn.dataset.qtyChange);
            const newQty = Math.max(0, parseInt(input.value) + change);
            this.updateLine(key, newQty);
          });
        });
        itemEl.querySelector('[data-qty-input]').addEventListener('change', e => {
          this.updateLine(key, parseInt(e.target.value) || 0);
        });
        itemEl.querySelector('[data-remove]').addEventListener('click', () => {
          this.updateLine(key, 0);
        });
      });

      const checkoutBtn = document.getElementById('cart-checkout');
      if (checkoutBtn) checkoutBtn.disabled = false;
      const totalEl = document.getElementById('cart-total');
      if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
    },

    async updateLine(key, quantity) {
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity })
        });
        const cart = await res.json();
        this.render(cart);
      } catch (err) {
        console.error('Cart update failed:', err);
        toast.show('Update failed');
      }
    },

    async addItem(formData) {
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        });
        if (!res.ok) {
          const err = await res.json();
          toast.show(err.description || 'Could not add to cart');
          return null;
        }
        const item = await res.json();
        await this.refresh();
        toast.show(`+ ${item.product_title}`);
        this.open();
        return item;
      } catch (err) {
        console.error('Add to cart failed:', err);
        toast.show('Add to cart failed');
        return null;
      }
    }
  };

  // ===== PRODUCT FORMS (AJAX add to cart) =====
  function initProductForms() {
    document.querySelectorAll('form[data-product-form]').forEach(form => {
      form.addEventListener('submit', async e => {
        e.preventDefault();
        // Validate youth size field if present and required
        const youthInput = form.querySelector('[data-youth-input]');
        const youthError = document.querySelector('[data-youth-error]');
        if (youthInput && youthInput.hasAttribute('required') && !youthInput.value.trim()) {
          youthInput.classList.add('has-error');
          if (youthError) youthError.removeAttribute('hidden');
          youthInput.focus();
          return;
        }
        if (youthInput) {
          youthInput.classList.remove('has-error');
          if (youthError) youthError.setAttribute('hidden', '');
        }
        const btn = form.querySelector('[type="submit"]');
        if (btn) {
          btn.disabled = true;
          const originalText = btn.textContent;
          btn.textContent = 'Adding...';
          await cartDrawer.addItem(new FormData(form));
          btn.textContent = originalText;
          btn.disabled = false;
        }
      });
    });
  }

  // ===== VARIANT PICKER =====
  function initVariantPicker() {
    document.querySelectorAll('[data-variant-picker]').forEach(picker => {
      const variants = JSON.parse(picker.dataset.variants || '[]');
      const optionsByName = {};

      picker.querySelectorAll('[data-option-group]').forEach(group => {
        const optionName = group.dataset.optionGroup;
        const optionIndex = parseInt(group.dataset.optionIndex);
        optionsByName[optionName] = { index: optionIndex, group };

        group.querySelectorAll('[data-option-value]').forEach(btn => {
          btn.addEventListener('click', () => {
            group.querySelectorAll('[data-option-value]').forEach(b => b.classList.remove('selected'));
            btn.classList.add('selected');
            updateSelectedVariant();
          });
        });
      });

      function getSelectedOptions() {
        const opts = [];
        Object.values(optionsByName)
          .sort((a, b) => a.index - b.index)
          .forEach(({ group }) => {
            const selected = group.querySelector('[data-option-value].selected');
            opts.push(selected ? selected.dataset.optionValue : null);
          });
        return opts;
      }

      function updateSelectedVariant() {
        const opts = getSelectedOptions();
        const variant = variants.find(v => {
          return v.options.every((val, i) => val === opts[i]);
        });

        const idInput = document.querySelector('[data-variant-id]');
        const priceEl = document.querySelector('[data-product-price]');
        const compareEl = document.querySelector('[data-product-compare]');
        const atcBtn = document.querySelector('[data-atc-btn]');

        // Check if all required options are selected
        const allOptionsSelected = opts.every(o => o !== null);

        if (variant && allOptionsSelected) {
          if (idInput) idInput.value = variant.id;
          if (priceEl) priceEl.textContent = formatMoney(variant.price);
          if (compareEl) {
            if (variant.compare_at_price && variant.compare_at_price > variant.price) {
              compareEl.textContent = formatMoney(variant.compare_at_price);
              compareEl.style.display = '';
            } else {
              compareEl.style.display = 'none';
            }
          }
          if (atcBtn) {
            if (variant.available) {
              atcBtn.disabled = false;
              atcBtn.textContent = 'ADD TO CART';
            } else {
              atcBtn.disabled = true;
              atcBtn.textContent = 'SOLD OUT';
            }
          }
        } else if (allOptionsSelected) {
          // All options selected but no matching variant
          if (idInput) idInput.value = '';
          if (atcBtn) {
            atcBtn.disabled = true;
            atcBtn.textContent = 'UNAVAILABLE';
          }
        } else {
          // Not all options selected yet
          if (idInput) idInput.value = '';
          if (atcBtn) {
            atcBtn.disabled = true;
            atcBtn.textContent = 'SELECT A SIZE';
          }
        }
        // Show/hide youth size field based on selected option
        const youthField = document.querySelector('[data-youth-field]');
        const youthInput = document.querySelector('[data-youth-input]');
        const youthError = document.querySelector('[data-youth-error]');
        if (youthField && youthInput) {
          const selectedOpts = getSelectedOptions();
          const isYouth = selectedOpts.some(opt => opt && opt.toLowerCase().includes('youth'));
          if (isYouth) {
            youthField.removeAttribute('hidden');
            youthInput.setAttribute('required', 'required');
          } else {
            youthField.setAttribute('hidden', '');
            youthInput.removeAttribute('required');
            youthInput.value = '';
            youthInput.classList.remove('has-error');
            if (youthError) youthError.setAttribute('hidden', '');
          }
        }
      }
    });
  }

  // ===== PRODUCT GALLERY (thumbnail clicks) =====
  function initProductGallery() {
    const main = document.getElementById('product-media-main');
    if (!main) return;
    document.querySelectorAll('[data-thumb]').forEach(thumb => {
      thumb.addEventListener('click', () => {
        document.querySelectorAll('[data-thumb]').forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        const src = thumb.dataset.fullSrc;
        const alt = thumb.dataset.fullAlt || '';
        main.querySelector('img').src = src;
        main.querySelector('img').alt = alt;
      });
    });
  }

  // ===== PRODUCT PAGE QTY =====
  function initProductQty() {
    const qtyControl = document.querySelector('.product__qty-control');
    if (!qtyControl) return;
    const input = qtyControl.querySelector('input');
    qtyControl.querySelector('[data-qty-minus]').addEventListener('click', () => {
      input.value = Math.max(1, parseInt(input.value) - 1);
    });
    qtyControl.querySelector('[data-qty-plus]').addEventListener('click', () => {
      input.value = parseInt(input.value) + 1;
    });
  }

  // ===== MOBILE NAV =====
  function initMobileNav() {
    const toggle = document.querySelector('[data-mobile-nav-toggle]');
    const nav = document.getElementById('mobile-nav');
    const close = document.querySelector('[data-mobile-nav-close]');
    if (!toggle || !nav) return;

    toggle.addEventListener('click', () => {
      nav.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
    if (close) {
      close.addEventListener('click', () => {
        nav.classList.remove('open');
        document.body.style.overflow = '';
      });
    }
    nav.querySelectorAll('a').forEach(a => {
      a.addEventListener('click', () => {
        nav.classList.remove('open');
        document.body.style.overflow = '';
      });
    });
  }

  // ===== SMOOTH ANCHOR SCROLL =====
  function initAnchorScroll() {
    document.querySelectorAll('a[href*="#"]').forEach(a => {
      a.addEventListener('click', e => {
        const href = a.getAttribute('href');
        // Only handle same-page anchors
        if (!href.includes('#')) return;
        const url = new URL(href, window.location.href);
        if (url.pathname !== window.location.pathname) return;
        const hash = url.hash;
        if (!hash || hash === '#') return;
        const target = document.querySelector(hash);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.pushState(null, '', hash);
      });
    });
  }

  // ===== HELPERS =====
  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, window.theme?.moneyFormat || '${{amount}}');
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function escapeHtml(str) {
    if (!str) return '';
    return str.replace(/[&<>"']/g, c => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[c]));
  }

  // ===== CART PAGE (not drawer) =====
  function initCartPage() {
    // Only run on the /cart page, not the drawer
    const cartPageItems = document.querySelectorAll('.page-template .cart-drawer__item');
    if (cartPageItems.length === 0) return;

    cartPageItems.forEach(itemEl => {
      const key = itemEl.dataset.lineKey;
      if (!key) return;

      // Qty +/- buttons
      itemEl.querySelectorAll('[data-qty-change]').forEach(btn => {
        btn.addEventListener('click', async () => {
          const input = itemEl.querySelector('[data-qty-input]');
          const change = parseInt(btn.dataset.qtyChange);
          const newQty = Math.max(0, parseInt(input.value) + change);
          await updateCartLine(key, newQty);
        });
      });

      // Qty input direct edit
      const qtyInput = itemEl.querySelector('[data-qty-input]');
      if (qtyInput) {
        qtyInput.addEventListener('change', async e => {
          await updateCartLine(key, parseInt(e.target.value) || 0);
        });
      }

      // Remove button
      const removeBtn = itemEl.querySelector('[data-remove]');
      if (removeBtn) {
        removeBtn.addEventListener('click', async () => {
          await updateCartLine(key, 0);
        });
      }
    });
  }

  async function updateCartLine(key, quantity) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      if (res.ok) {
        // Reload the page to reflect changes
        window.location.reload();
      } else {
        toast.show('Update failed');
      }
    } catch (err) {
      console.error('Cart update failed:', err);
      toast.show('Update failed');
    }
  }

  // ===== INIT =====
  document.addEventListener('DOMContentLoaded', () => {
    cartDrawer.init();
    initProductForms();
    initVariantPicker();
    initProductGallery();
    initProductQty();
    initMobileNav();
    initAnchorScroll();
    initCartPage();
  });

  // Expose for inline access
  window.VortecTheme = { cartDrawer, toast };
})();
